import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3, AlertTriangle } from 'lucide-react';

const COMPANY = [
  { label: 'About', to: '/about', testid: 'footer-about' },
  { label: 'Safety', to: '/safety', testid: 'footer-safety' },
  { label: 'Contact', to: '/contact', testid: 'footer-contact' },
];

const LEGAL = [
  { label: 'Legal Center', to: '/legal', testid: 'footer-legal-center' },
  { label: 'Terms of Service', to: '/terms', testid: 'footer-terms' },
  { label: 'Privacy Policy', to: '/privacy', testid: 'footer-privacy' },
  { label: 'Refund Policy', to: '/refund-policy', testid: 'footer-refund' },
  { label: 'Safety Policy', to: '/safety', testid: 'footer-safety-policy' },
  { label: 'Code of Conduct', to: '/code-of-conduct', testid: 'footer-conduct' },
  { label: 'Acceptable Use Policy', to: '/acceptable-use', testid: 'footer-acceptable-use' },
];

const linkClass =
  'text-sm text-slate-400 hover:text-amber-300 transition-colors duration-200 focus:outline-none focus-visible:text-amber-300 focus-visible:underline underline-offset-4';

export const SiteFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="w-full border-t border-slate-800 bg-slate-950 text-slate-300 safe-bottom"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1.2fr]">
          {/* Brand */}
          <div className="min-w-0">
            <div className="flex items-center gap-2.5">
              <div className="p-2 bg-gradient-to-br from-amber-400 via-amber-500 to-amber-600 rounded-lg">
                <BarChart3 className="h-5 w-5 text-slate-900" />
              </div>
              <span
                className="text-lg font-bold bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Option Wizard
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Educational options-analysis and decision-support tools. Not financial advice.
            </p>
            <div className="mt-4 flex items-start gap-2 text-xs text-slate-500">
              <AlertTriangle className="h-3.5 w-3.5 text-amber-500 flex-shrink-0 mt-0.5" />
              <span>Options trading involves substantial risk of loss. Use at your own risk.</span>
            </div>
          </div>

          {/* Company */}
          <nav aria-label="Company" className="min-w-0">
            <h3 className="text-xs font-semibold tracking-widest uppercase text-slate-500">Company</h3>
            <ul className="mt-4 space-y-3">
              {COMPANY.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className={linkClass} data-testid={l.testid}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Legal */}
          <nav aria-label="Legal" className="min-w-0">
            <h3 className="text-xs font-semibold tracking-widest uppercase text-slate-500">Legal</h3>
            <ul className="mt-4 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className={linkClass} data-testid={l.testid}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {year} Option Wizard. All rights reserved.</p>
          <p className="text-xs text-slate-600">For educational purposes only — not investment advice.</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
